import React from 'react';

export const ClientPerformanceContext = React.createContext({
	active: { value: null, set: () => null },
});
